<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid upload-container p-0">

    <div class="row">
      <div class="col-12 px-0">
        <select class="form-control" v-bind:id="'select_' +  getId()" data-fouc v-on:change="onChange" v-select>
          <option value="" style="">{{placeholder}}</option>
          <option v-for="option in items" v-bind:value="option.Id">
            {{ option.Name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>

  var items = [];
  var placeholder = "";

  export default {
    name: "priority-selector",
    props: {
      
      value: {
        type: String,
        default: null
      },
    },
    data() {
      return {
        visible: this.visibility,
        items,
        placeholder
      };
    },
    methods: {
      getOptionStyle(v) {
        return v;
      },
      onChange() {
        this.$emit('change', $("#select_" + this.getId()).val());
      },
      input(event) {
      },
      getId() {
        return this._uid;
      },
      doChange() {
      },
      getData() {
        return this.items;
      },
      async load(selected) {
        try {
          this.items = [];
          this.$http.get('/api/priority/Search?').then(async response => {
            this.items = response.data;
            $('#' + 'select_' + this.getId()).select2();

          }).then((async response => {
            if (selected != null) {
              $("#select_" + this.getId()).val(selected);
              $("#select_" + this.getId()).trigger('change');
            }
          }
          ));
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      value: function (newVal, oldVal) {
        $("#select_" + this.getId()).val(newVal);
        $("#select_" + this.getId()).trigger('change');
      }
    },
    mounted() {
      this.load(this.value);
      $("#select_" + this.getId()).change(this.onChange);
      this.placeholder = this.$t('select_priority')

    }
  };
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/priority/priority-selector.vue